import { css } from '@emotion/react'

export const wrapper = css`
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  cursor: pointer;
`

export const title = css`
  margin-bottom: 14px;
`
